import { render, staticRenderFns } from "./FFnewBox.vue?vue&type=template&id=6b64786b&"
import script from "./FFnewBox.vue?vue&type=script&lang=js&"
export * from "./FFnewBox.vue?vue&type=script&lang=js&"
import style0 from "./FFnewBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports